export const parsePnrInput = (value: string, oldValue: string) => {
  const date = new Date();
  const currentCentury = date.getFullYear().toString().slice(2, 2);
  const inputCentury = value.slice(0, 2);
  const pnrRegex =
    "(19|20)[0-9]{2}[- ]?((0[0-9])|(10|11|12))[- ]?(([0-2][0-9])|(3[0-1])|(([7-8][0-9])|(6[1-9])|(9[0-1])))[- ]?[0-9]{4}";

  let pnr = "";
  let valid = false;

  if (value.includes("-") || value.length > 0) {
    if (value.length === 2 && inputCentury !== "19" && inputCentury !== "20") {
      if (inputCentury <= currentCentury) {
        pnr = "20" + value.replace("-", "");
      } else {
        pnr = "19" + value.replace("-", "");
      }
    } else {
      if (value.length === 8 && !value.includes("-") && value.length > oldValue.length) {
        pnr = value + "-";
      } else if (value.length >= 9 && !value.includes("-") && value.length > oldValue.length) {
        const start = value.slice(0, 8);
        const end = value.slice(8, 1);

        pnr = start + "-" + end;
      } else if (value.length < oldValue.length || value.length > 0) {
        pnr = value;
      } else {
        pnr = oldValue;
      }

      if (value.match(pnrRegex) === null) {
        valid = false;
      } else {
        valid = true;
      }
    }
  }
  return { value: pnr, valid: valid };
};
